import * as React from 'react';
import { CSVLink } from 'react-csv';

interface CsvDownloadButtonProps {
  data: string[][];
  label: string;
  fileName: string;
}

const CsvDownloadButton: React.FC<CsvDownloadButtonProps> = ({ data, label, fileName }) => {
  return (
    <CSVLink filename={fileName} separator={','} className="btn btn-primary" data={data} target="_blank">
      {label}
    </CSVLink>
  );
};

export default CsvDownloadButton;
